// React
import { useState } from "react";
import { useEffect } from "react";
// Components
import DeleteComponentButton from "./DeleteComponent";
import OpenDialog from "components/Dialogs/OpenDialog";
import { InfoTitle } from "../ImageDetailsElements";
import { ButtonInfo } from "../ObjectDetails/ObjectDetailsElements";
// Helpers
import { isUrl } from "helpers/isUrl";
// Dependencies
import { Grid } from "@mui/material";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";

export default function TableEvent({ component, deleteButton }) {
  delete component?.object;
  const [infoOperation, setInfoOperation] = useState({});

  const isoDateToString = (isoDate) => {
    const date = new Date(isoDate);
    return date.toString().substring(0, 25);
  };

  useEffect(() => {
    const omit = [
      "mongoId",
      "userId",
      "locationComponentId",
      "pointTypeComponentId",
      "adminCompanyId",
      "locationComponent",
      "point_library_component_id",
      "pointTypeComponent",
      "attributes",
      "date",
      "componentFiles",
      "user",
      "fieldsCaptureMedia",
      "media",
    ];

    Object.keys(component).map((key) => {
      if (omit.includes(key)) return null;
      let value = component[key];
      if (!value) {
        return null;
      }
      setInfoOperation((prev) => ({ ...prev, [key]: value }));
      return null;
    });

    setInfoOperation((prev) => ({
      ...prev,
      Date: isoDateToString(component.date),
      Latitude: component.locationComponent.latitude || 0,
      Longitude: component.locationComponent.longitude || 0,
    }));
  }, [component]);

  const reduceAttributes = () => {
    const filteredAttributes = component?.attributes?.map((item) => {
      let newItem = { ...item };
      try {
        if (typeof JSON.parse(item.value) === "object")
          newItem.value = JSON.parse(item.value);
      } catch (error) {
        return item;
      }
      return newItem;
    });
    return filteredAttributes;
  };

  return (
    <InfoTitle>
      <Grid item xs={12} md={12} lg={12} xl={12}>
        <section className="main-tables-container">
          <div className="main-currency-table">
            <div className="currency-table--container">
              <table>
                {Object.keys(infoOperation).map((key) => {
                  return (
                    <tr>
                      <td>{key}</td>
                      <td className="table__right">{infoOperation[key]}</td>
                    </tr>
                  );
                })}
                {component &&
                  reduceAttributes()?.map((item) => {
                    return (
                      <tr>
                        <td style={{ display: "flex", width: "100%" }}>
                          {item?.alias && item?.alias.length > 0
                            ? item.alias
                            : item.name}
                          {item?.operation ? (
                            <OperationInfo content={item} />
                          ) : (
                            <></>
                          )}
                        </td>
                        <td className="table__right">
                          {isUrl(item.value) ? (
                            <a
                              href={item.value}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Go to link
                            </a>
                          ) : typeof item.value !== "object" ? (
                            item.value
                          ) : (
                            item.value.value
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </table>
              {deleteButton && (
                <DeleteComponentButton pointComponentId={component.id} />
              )}
            </div>
          </div>
        </section>
      </Grid>
    </InfoTitle>
  );
}
const OperationInfo = ({ content }) => {
  const [dialog, setDialog] = useState({
    open: false,
    actions: {
      disagree: "Close",
    },
  });

  const handleShow = () => {
    setDialog((current) => ({
      ...current,
      open: true,
    }));
  };
  return (
    <ButtonInfo>
      {
        <ContactSupportIcon
          sx={{
            fontSize: "1.8rem",
            color: "#3f51b5",
          }}
          onClick={handleShow}
        />
      }
      <OpenDialog
        openDialog={dialog?.open}
        setOpenDialog={setDialog}
        execute={dialog.execute}
        content={{
          title: "Operation detail",
          description: (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "25px",
              }}
            >
              <div>
                <span>
                  The result of this field is obtained from the following
                  expression:
                </span>
              </div>
              <div>
                <math-field
                  read-only
                  className="math-field"
                  id={content?.name}
                  style={{
                    display: "inline-block",
                    minWidth: "200px",
                    width: "100%",
                    minHeight: "60px",
                    fontSize: "2.2rem",
                    border: "none",
                  }}
                  value={content?.operation}
                />
              </div>
            </div>
          ),
          ...dialog.actions,
        }}
      />
    </ButtonInfo>
  );
};
